{
  "#DASHBOARD": {
    "APP": "Dashboard",
    "TITLE": "Dashboard"
  }
}
